import { __decorate, __param } from 'tslib';
import { Inject, NgZone, ElementRef, Optional, SkipSelf, Input, Output, Directive, NgModule } from '@angular/core';
import { tuiDefaultProp, tuiPure } from '@taiga-ui/cdk/decorators';
import { tuiZoneOptimized } from '@taiga-ui/cdk/observables';
import { TUI_ACTIVE_ELEMENT } from '@taiga-ui/cdk/tokens';
import { Observable } from 'rxjs';
import { map, startWith, distinctUntilChanged, skip } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'rxjs';
var TuiActiveZoneDirective_1;
let TuiActiveZoneDirective = TuiActiveZoneDirective_1 = class TuiActiveZoneDirective {
    constructor(active$, ngZone, elementRef, directParentActiveZone) {
        this.active$ = active$;
        this.ngZone = ngZone;
        this.elementRef = elementRef;
        this.directParentActiveZone = directParentActiveZone;
        this.subActiveZones = [];
        this.tuiActiveZoneParent = null;
        this.tuiActiveZoneChange = this.active$.pipe(map(element => !!element && this.contains(element)), startWith(false), distinctUntilChanged(), skip(1), tuiZoneOptimized(this.ngZone));
        if (this.directParentActiveZone) {
            this.directParentActiveZone.addSubActiveZone(this);
        }
    }
    set tuiActiveZoneParentSetter(zone) {
        this.setZone(zone);
    }
    ngOnDestroy() {
        if (this.directParentActiveZone) {
            this.directParentActiveZone.removeSubActiveZone(this);
        }
        if (this.tuiActiveZoneParent) {
            this.tuiActiveZoneParent.removeSubActiveZone(this);
        }
    }
    contains(node) {
        return (this.elementRef.nativeElement.contains(node) ||
            this.subActiveZones.some((item, index, array) => array.indexOf(item) === index && item.contains(node)));
    }
    setZone(zone) {
        if (this.tuiActiveZoneParent) {
            this.tuiActiveZoneParent.removeSubActiveZone(this);
        }
        if (zone) {
            zone.addSubActiveZone(this);
        }
        this.tuiActiveZoneParent = zone;
    }
    addSubActiveZone(activeZone) {
        this.subActiveZones = [...this.subActiveZones, activeZone];
    }
    removeSubActiveZone(activeZone) {
        const index = this.subActiveZones.findIndex(item => item === activeZone);
        this.subActiveZones = [
            ...this.subActiveZones.slice(0, index),
            ...this.subActiveZones.slice(index + 1),
        ];
    }
};
TuiActiveZoneDirective.ɵfac = function TuiActiveZoneDirective_Factory(t) { return new (t || TuiActiveZoneDirective)(ɵngcc0.ɵɵdirectiveInject(TUI_ACTIVE_ELEMENT), ɵngcc0.ɵɵdirectiveInject(NgZone), ɵngcc0.ɵɵdirectiveInject(ElementRef), ɵngcc0.ɵɵdirectiveInject(TuiActiveZoneDirective_1, 12)); };
TuiActiveZoneDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TuiActiveZoneDirective, selectors: [["", "tuiActiveZone", "", 5, "ng-container"], ["", "tuiActiveZoneChange", "", 5, "ng-container"], ["", "tuiActiveZoneParent", "", 5, "ng-container"]], inputs: { tuiActiveZoneParentSetter: ["tuiActiveZoneParent", "tuiActiveZoneParentSetter"] }, outputs: { tuiActiveZoneChange: "tuiActiveZoneChange" }, exportAs: ["tuiActiveZone"] });
TuiActiveZoneDirective.ctorParameters = () => [
    { type: Observable, decorators: [{ type: Inject, args: [TUI_ACTIVE_ELEMENT,] }] },
    { type: NgZone, decorators: [{ type: Inject, args: [NgZone,] }] },
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] },
    { type: TuiActiveZoneDirective, decorators: [{ type: Optional }, { type: SkipSelf }, { type: Inject, args: [TuiActiveZoneDirective_1,] }] }
];
__decorate([
    Input('tuiActiveZoneParent'),
    tuiDefaultProp()
], TuiActiveZoneDirective.prototype, "tuiActiveZoneParentSetter", null);
__decorate([
    Output()
], TuiActiveZoneDirective.prototype, "tuiActiveZoneChange", void 0);
__decorate([
    tuiPure
], TuiActiveZoneDirective.prototype, "setZone", null);
TuiActiveZoneDirective = TuiActiveZoneDirective_1 = __decorate([ __param(0, Inject(TUI_ACTIVE_ELEMENT)),
    __param(1, Inject(NgZone)),
    __param(2, Inject(ElementRef)),
    __param(3, Optional()),
    __param(3, SkipSelf()),
    __param(3, Inject(TuiActiveZoneDirective_1))
], TuiActiveZoneDirective);

let TuiActiveZoneModule = class TuiActiveZoneModule {
};
TuiActiveZoneModule.ɵfac = function TuiActiveZoneModule_Factory(t) { return new (t || TuiActiveZoneModule)(); };
TuiActiveZoneModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiActiveZoneModule });
TuiActiveZoneModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiActiveZoneDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiActiveZone]:not(ng-container), [tuiActiveZoneChange]:not(ng-container), [tuiActiveZoneParent]:not(ng-container)',
                exportAs: 'tuiActiveZone'
            }]
    }], function () { return [{ type: ɵngcc1.Observable, decorators: [{
                type: Inject,
                args: [TUI_ACTIVE_ELEMENT]
            }] }, { type: ɵngcc0.NgZone, decorators: [{
                type: Inject,
                args: [NgZone]
            }] }, { type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }, { type: TuiActiveZoneDirective, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }, {
                type: Inject,
                args: [TuiActiveZoneDirective_1]
            }] }]; }, { tuiActiveZoneChange: [{
            type: Output
        }], tuiActiveZoneParentSetter: [{
            type: Input,
            args: ['tuiActiveZoneParent']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiActiveZoneModule, [{
        type: NgModule,
        args: [{
                declarations: [TuiActiveZoneDirective],
                exports: [TuiActiveZoneDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiActiveZoneModule, { declarations: [TuiActiveZoneDirective], exports: [TuiActiveZoneDirective] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiActiveZoneDirective, TuiActiveZoneModule };

